import React from "react";
import PeopleSummary from "components/PeopleSummary/PeopleSummary";
import BasePaper from "components/Base/BasePaper";
import type { Person } from "api/Community/CommunityInterfaces";

interface Props {
  person: Person | null;
  interactionToken?: string;
  onPersonUpdated?: (updated: Person) => void;
}

const PeopleInfoSection: React.FC<Props> = ({
  person,
  interactionToken,
  onPersonUpdated,
}) => {
  return (
    <BasePaper>
      <PeopleSummary
        person={person}
        interactionToken={interactionToken}
        onPersonUpdated={onPersonUpdated}
      />
    </BasePaper>
  );
};

export default PeopleInfoSection;